import React, { Suspense } from 'react'
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from '@commonComponents/ErrorBoundary'
import { Tab, TabItem } from '@commonComponents/formComponents/Tab'
import ShipmentInfoProvider from '../../context/shipmentInfo.js/index.js'
import { CustomLoader } from '@commonComponents/formComponents/loader'
import { ErrorMessage } from '@commonComponents/formComponents/ErrorMessage'
import { SAVE_FORM_ES, DELETE_ENTITY_ES } from '../../ES_App/api/apiEvents'
import TranslateContextProvider from '../../NL_App/formSections/TranslateContext'
import RubberBindingInfoProvider from '../../context/rubberBindingInfoProvider'
import { useGetDropdownData } from '@hooks/useGetDropdownData'
import { useGetFormData } from '@hooks/useGetFromData'
import BillingForm from '../../commonComponents/commonBillingTab/index'
const HeaderContainer = React.lazy(() => import('../../AES_App/formSections/header'))
const Transport = React.lazy(() => import('../../AES_App/formSections/transport'))
const ContainerTab = React.lazy(() => import('../../AES_App/formSections/containers'))
const ValueBuildUpTab = React.lazy(() => import('../../AES_App/formSections/valueBuildUpTab'))
const InvoiceTab = React.lazy(() => import('../../AES_App/formSections/items'))
const NotesTab = React.lazy(() => import('../../EUForms/notes'))

const ValidateError = React.lazy(() => import('../../commonComponents/validateError').then(module => ({ default: module.ValidateError })))
// import {
//   resetServerErrors
// } from '../../commonActions/serverErrorAction'
import { Portal } from '../../commonComponents/portal';
import { MemoizeExchangeRates } from '../../commonComponents/ExchangeRates';
import { getJobWheels, isShipmentDisabled } from '../../../components/util'
import { resetServerError } from '../reducer/serverErrorSlice.js';
import DisplayErrorServerAES from './displayErrorServerAES.js';
import ErrorInitializer from '../containers/errorInitializer.js';
import { useEffect } from 'react';
import { updateShipmentFieldValue } from '../reducer/headerSlice.js';
import CertDropdown from '../../../header/ButtonMapper/certDropdown';
// import { initializeErrors } from '../reducer/validationSlice.js';
// import { createValidationStructure } from '../../../components/Helper/index.js';
// import { fieldPatterns } from '../util/fieldPatterns';
// import validate from 'validate.js'
const DisplayError = React.lazy(() => import('@commonComponents/displayError'))


const AESForm = ({
  shipmentCountry,
  serviceType,
  formType,
  shipId: shipmentId,
  translate,
  rubberBindingInfo,
  kxUser,
  kxUserBasicInfo,
  currentJobData,
  allDocs,
  kxEngineUserInfo,
  ...props
}) => {
  let jobWheels = getJobWheels(currentJobData);
  let currentJobState = jobWheels['ES_ENTRY_JOB_WHEEL']?.value?.state || ''
  let customJobState = jobWheels['ES_CUSTOM_JOB_WHEEL']?.value?.state || ''
  let currentJobCircuitState = jobWheels['CUSTOM_RELEASE_PROCESS']?.value?.state || ''
  let brokerHouseState = jobWheels ? jobWheels['SHIPMENT_BROKER_HOUSE_PROCESS']?.value?.state : ''
  const dispatch = useDispatch()
  const isFormDisabled = isShipmentDisabled(currentJobState, customJobState, currentJobCircuitState, brokerHouseState)

  // ,({ data: { eventMessage: { headerTab } } })=>{
  //   const validateHeaderErrors=validate(headerTab,fieldPatterns()().headerTab) || {}
  //   const headerErrors = createValidationStructure(validateHeaderErrors)
  //   dispatch(initializeErrors({headerTab:headerErrors}))
  // }
  const circuit = currentJobCircuitState?.replace('STATE_RELEASE_', '').toLowerCase()
  // const headerTab = useSelector((state) => state.headerReducer.headerTab)
  // console.log("headerTab ====", headerTab)
  const observation = useSelector((state) => state.headerReducer.headerTab.observation)
  const response = useGetDropdownData({
    countryCode: shipmentCountry,
    subSystem: formType,
    shipmentType: 'EXPORT',
  })
  const { loader, isMounted, error } = useGetFormData({
    countryCode: shipmentCountry,
    version: formType,
    shipmentType: 'EXPORT',
    shipmentId,
  }, (response) => {
    dispatch(resetServerError())
  })
  useEffect(() => {
    dispatch(updateShipmentFieldValue({ circuit }))
  }, [circuit])
  let content = <div>Loading...</div>
  if (error) content = <ErrorMessage>An Error Occured In Loading AES Form</ErrorMessage>
  else if (loader) content = <CustomLoader>Preparing Form...</CustomLoader>
  else if (isMounted) {
    content = (
      <ErrorBoundary>
        <div style={{ marginTop: '5px' }} className='tabContainer C88'>
          <TranslateContextProvider translate={translate}>
            <ShipmentInfoProvider
              countryCode={shipmentCountry}
              version={formType}
              deleteEvent={DELETE_ENTITY_ES}
              saveEvent={SAVE_FORM_ES}
              serviceType={serviceType}
              isDisabled={isFormDisabled}
              currentJobState={currentJobState} // no need already in jobWheels
              shipmentId={shipmentId}
              kxUser={kxUser}
              allDocs={allDocs}
              currentJobData={currentJobData}
              customJobState={customJobState}
              kxEngineUserInfo={kxEngineUserInfo}
            >
               {
                <Portal targetElementId='es-certificates'>
                  <CertDropdown shipId={shipmentId} observation={observation} kxUserBasicInfo={kxUserBasicInfo} kxUser={kxUser} />
                </Portal>
              }
              <RubberBindingInfoProvider rubberBindingInfo={rubberBindingInfo}>
               
                <Portal targetElementId="exchangeRatesContainer">
                  <MemoizeExchangeRates translate={translate} DropDownReducer='dropDownReducer' />
                </Portal>
                <Suspense fallback={<div>Loading...</div>}>
                  <DisplayErrorServerAES />
                  <ErrorInitializer translate={translate}>
                    {({ repeatableValidationMethodsTransport, repeatableValidationMethodsParties }) => {
                      return (
                        <Tab className='euForm' translate={translate}>
                          <TabItem id='headerTab' title='Header'>
                            <DisplayError tabName="headerTab" />
                            <HeaderContainer
                              kxUser={kxUser}
                              shipmentId={shipmentId}
                              version={formType}
                              jobWheels={jobWheels}
                              lowerEnv={props?.headerProps?.lowerEnv}
                              searchByID={props.searchByID}
                              repeatableValidationMethods={repeatableValidationMethodsParties}
                            />
                          </TabItem>
                          <TabItem id='transportTab' title='Transport'>
                            <DisplayError tabName="transportTab" />
                            <Transport repeatableValidationMethods={repeatableValidationMethodsTransport} />
                          </TabItem>
                          <TabItem id='containerTab' title='Containers'>
                            <ContainerTab />
                          </TabItem>
                          <TabItem id='valueBuildUpTab' title='Value Build Up'>
                            <ValueBuildUpTab />
                          </TabItem>
                          <TabItem id='itemsTab' title='Items'>
                            <DisplayError tabName="itemsTab" />
                            <InvoiceTab />
                          </TabItem>
                          {kxEngineUserInfo?.isEngineUser != "true" && <TabItem id='billingTab' title='Billing'>
                            <BillingForm
                              kxUserBasicInfo={kxUserBasicInfo}
                              jobWheels={jobWheels}
                              currentJobData={currentJobData}
                            />
                          </TabItem>}
                          <TabItem title='Notes'>
                            <NotesTab id="notesTab" title='Notes'
                              shipmentId={shipmentId}
                              fullName={kxUserBasicInfo?.fullName}
                              translate={translate}
                            ></NotesTab>
                          </TabItem>
                        </Tab>
                      )
                    }}
                  </ErrorInitializer>
                </Suspense>
              </RubberBindingInfoProvider>
            </ShipmentInfoProvider>
          </TranslateContextProvider>
        </div>
        <div className='toast'></div>
      </ErrorBoundary>
    )
  } else {
    return null;
  }
  return content
}
export default React.memo(AESForm)
